import Vue from 'vue'
import App from './App.vue'
import createRouter from './router'
import createStore from './store'
const placeholderimagegray = require('@/assets/default/placeholder.png')

import VueLazyload from 'vue-lazyload'
import global from '@/utils/global'
import { initializeApp } from 'firebase/app'
import { getAnalytics, logEvent, isSupported } from 'firebase/analytics'
import VueMeta from 'vue-meta'
import firebaseConfig from '../firebaseConfig' // 引入Firebase配置

// 事件队列管理器
class EventQueueManager {
	constructor() {
		this.queue = []
		this.initialized = false
	}

	add(event) {
		this.initialized ? this.processEvent(event) : this.queue.push(event)
	}

	processEvent(event) {
		const { type, ...data } = event
		if (type === 'log') {
			Vue.prototype.$logEvent(data.event, data.params)
		} else if (type === 'track') {
			Vue.prototype.$eventrack(data.msg, data.method, data.map)
		}
	}

	processQueue() {
		this.initialized = true
		while (this.queue.length > 0) {
			this.processEvent(this.queue.shift())
		}
	}
}

const eventQueueManager = new EventQueueManager()

Vue.prototype.$global = global

Vue.use(VueMeta)

Vue.use(VueLazyload, {
	preLoad: 1.3,
	error: placeholderimagegray,
	loading: placeholderimagegray,
	attempt: 1,
})

// 初始化默认事件追踪方法
function initializeDefaultTracking() {
	Vue.prototype.$logEvent = (event, params = {}) => {
		eventQueueManager.add({ type: 'log', event, params })
	}

	Vue.prototype.$eventrack = (msg, method, map = {}) => {
		eventQueueManager.add({ type: 'track', msg, method, map })
	}
}

// Firebase 初始化与配置
async function initializeFirebaseAnalytics() {
	try {
		const isAnalyticsSupported = await isSupported()
		if (!isAnalyticsSupported) {
			console.warn('Firebase Analytics is not supported in this environment')
			return null
		}

		const fconfig = window?.__INITIAL_STATE__?.domainConfig?.firebase || firebaseConfig
		const app = initializeApp(fconfig)
		return getAnalytics(app)
	} catch (error) {
		console.error('Failed to initialize Firebase:', error)
		return null
	}
}

// 设置生产环境分析
async function setupAnalytics() {
	const analytics = await initializeFirebaseAnalytics()
	if (!analytics) return

	logEvent(analytics, 'in_page')

	// 更新追踪方法
	Vue.prototype.$logEvent = (event, params = {}) => {
		console.log(`[Analytics] ${event}`, params)
		logEvent(analytics, event, params)
	}

	Vue.prototype.$eventrack = (msg, method, map = {}) => {
		const params = {
			timestamp: new Date().toISOString(),
			message: msg,
			method,
			...map,
		}
		console.log(`[Analytics] ${msg}`, params)
		logEvent(analytics, msg, params)
	}
  

	// 处理队列中的事件
	eventQueueManager.processQueue()
}

// 设置原生接口
function setupNativeInterfaces() {
	Vue.prototype.$adClick = (message) => {
		if (typeof JSCallAndroid !== 'undefined' && typeof JSCallAndroid.adClick === 'function') {
			console.log(message)
			JSCallAndroid.adClick(message)
		} else {
			console.log(`Ad Click (no native): ${message}`)
		}
	}

	Vue.prototype.$adPosition = (message) => {
		if (typeof JSCallAndroid !== 'undefined' && typeof JSCallAndroid.adPosition === 'function') {
			console.log(message)
			JSCallAndroid.adPosition(message)
		} else {
			console.log(`Ad Position (no native): ${message}`)
		}
	}
}

// 初始化应用
if (typeof window !== 'undefined') {
	initializeDefaultTracking()
	setupAnalytics()
	setupNativeInterfaces()
} else {
	// 服务端简单日志记录
	const serverLog = (type, message, data) => console.log(`[Server][${type}]`, message, data)
	Vue.prototype.$logEvent = (event, params) => serverLog('Event', event, params)
	Vue.prototype.$eventrack = (msg, method, map) => serverLog('Track', msg, { method, ...map })
	Vue.prototype.$adClick = (msg) => serverLog('AdClick', msg)
	Vue.prototype.$adPosition = (msg) => serverLog('AdPosition', msg)
}

export default function createApp() {
	const router = createRouter()
	const store = createStore()
	const app = new Vue({
		router,
		store,
		render: (h) => h(App),
	})
	return {
		app,
		router,
		store,
	}
}
